export default {
  computed: {
    colorRedOld() {
      return "#7a0c06";
    },
    colorRed() {
      return"#780C06";
    },
    colorPurple() {
      return "#55067a";
    },
    colorBlue1(){
      return "#94A7BF";
    },
    colorBlue1Old() {
      return "#93A6BE";
    },
    colorBlue2() {
      // return "#445872";
      return "#394a5f";
    },
    colorBlue3() {
      return "#46648E";
    },
    colorBlue4() {
      // return "#38B6FF";
      return "#56c1ff";
    },
    colorBlue5() {
      return "#0d2c50";
    },
    colorBlack1() {
      return "#272727";
    }
  },
  methods: {
    openLink(url){
      window.open(url,'_blank','noreferrer');
    },
  }
}